import {
  ADD_NEW_BRAND_V2,
  CLEAR_LOGO_LIST,
  EDIT_BRAND_NAME_V2,
  EDIT_BRAND_SALE_V2,
  EDIT_BRAND_STATION_V2,
  GET_LOGO,
  LOAD_BRANDS_NEW,
  LOAD_BRANDS_SALES_V2,
  NEW_BRAND_SALE_V2,
  NEW_BRAND_STATION,
  SET_BRANDS_COMPANY,
  SET_BRANDS_NAMES_V2,
  SET_BRANDS_NEW,
  SET_BRANDS_SALES_V2,
  SET_BRANDS_STATION,
} from "redux/reducers/brands/brandsReducer";
import { api_post, api_get, api_put, PROYECT } from "services/api";
import { setSnackbar } from "../search/searchActions";

export const handleSetCompany = (data) => ({
  type: SET_BRANDS_COMPANY,
  payload: data
})

export const handleSetStation = (data) => ({
  type: SET_BRANDS_STATION,
  payload: data
})

export const getBrandsV2 = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands`;
  return async (dispatch) => {
    dispatch({ type: LOAD_BRANDS_NEW })
    await api_get(url).then(resp => {
      dispatch({
        type: SET_BRANDS_NEW,
        payload: resp
      })
    }).catch(err  => dispatch(setSnackbar(err)))
  }
}

export const getBrandNamesV2 = (token) => {
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/names`;
  return async (dispatch) => {
    dispatch({ type: LOAD_BRANDS_NEW })
    await api_get(url, auth).then(resp => {
      dispatch({
        type: SET_BRANDS_NAMES_V2,
        payload: resp
      })
    })

  }
}

export const getBrandSalesV2 = (token) => {
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/sales`;
  return async (dispatch) => {
    dispatch({ type: LOAD_BRANDS_SALES_V2 })
    await api_get(url, auth).then(resp => {
      dispatch({
        type: SET_BRANDS_SALES_V2,
        payload: resp
      })
    })

  }
}

export const addNewBrandV2 = (form, token) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/names`;
  const auth = { headers: { authorization: `${token}` } };
  return async (dispatch) => {
    await api_post(url, form, auth).then(resp => {
      dispatch({
        type: ADD_NEW_BRAND_V2,
        payload: resp
      })
    })
  }
}

export const editBrandNameV2 = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/names/${id}`;
  const auth = { headers: { authorization: `${token}` } };
  return async (dispatch) => {
    try{
      await api_put(url, form, auth).then(resp => {
        dispatch({
          type: EDIT_BRAND_NAME_V2,
          payload: resp
        })
      })
    }
    catch(err){
      dispatch(setSnackbar(err))
    }
  }
}

export const addNewBrandStationV2 = (form, token) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands`;
  const auth = { headers: { authorization: `${token}` } };
  return async (dispatch) => {
    try{
      await api_post(url, form, auth).then(resp => {
        dispatch({
          type: NEW_BRAND_STATION,
          payload: resp
        })
        dispatch(setSnackbar(`${form.alias} creado`, "success"))
      })
    } catch(err){
      dispatch(setSnackbar(err))
    }
  }
}

export const editNewBrandStationV2 = (id, form, token, logo) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/${id}`;
  const auth = { headers: { authorization: `${token}`, "Content-Type": "multipart/form-data" } };
  const formData = new FormData();
  for (const key in form) {
  if (form[key] !== undefined && form[key] !== null) {
      formData.append(key, form[key]);
    }
  }
  if(logo?.name){
    formData.append("logo", logo, logo.name)
  }
  return async (dispatch) => {
    try{
      await api_put(url, formData, auth).then(resp => {
        dispatch({
          type: EDIT_BRAND_STATION_V2,
          payload: resp
        })
        dispatch(setSnackbar(`${resp.alias} actualizado`, "success"))
      })
    }
    catch(err){
      dispatch(setSnackbar(err))
    }
  }
}

export const addNewBrandSaleV2 = (form, token) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/sales`;
  const auth = { headers: { authorization: `${token}` } };
  return async (dispatch) => {
    await api_post(url, form, auth).then(resp => {
      dispatch({
        type: NEW_BRAND_SALE_V2,
        payload: resp
      })
    })
  }
}

export const editBrandSaleV2 = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/sales/${id}`;
  const auth = { headers: { authorization: `${token}` } };
  return async (dispatch) => {
    await api_put(url, form, auth).then(resp => {
      dispatch({
        type: EDIT_BRAND_SALE_V2,
        payload: resp
      })
    })
  }
}

export const getLogo = (idStation, addLogos = true) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/logo/${idStation}`;
  return async (dispatch) => {
    await api_get(url).then(resp => {
      if(resp?.length > 0){
        dispatch({
          type: GET_LOGO,
          payload: {logos:resp, addLogos}
        })
      }
    }).catch(error => dispatch(setSnackbar(error)))
  }
}

export const clearLogos = () =>({
  type: CLEAR_LOGO_LIST,
})
